module.exports = __webpack_public_path__ + "img/about-d.b0cf8838.webp";